import "../styles/index.scss";
import "./routing.js";
import "./nav.js";

document.getElementById("currentYear").innerHTML = new Date().getFullYear();
